import React from "react";
import HeaderSec from "../../HeaderSec/HeaderSec";
import FooterComp from "../../FooterComp/FooterComp";
import AboutSecComp from "../AboutSecComp";
import { Grid, Typography } from "@mui/material";
import statutory from '../../../Assets/img/statutory.png'

const StatutoryInformation = () => {
  const section1 = [
    "GuideStar India is an initiative of Civil Society Information Services India.",
    "Civil Society Information Services India is a public charitable trust registered in Delhi on 27/01/2009 vide registration number 371. ",
    "We are tax exempt under section 12A of the Income Tax Act, 1961 vide registration No. DIT (E)/2009-10/DEL-CR-20523-04022010/1433 dated 04.02.2010. The registration was renewed for 10 years on 11/03/2026 from AY 2027-28 to AY 2036-37 vide unique registration number AABTC0541K25DL01 and Document Identification Number ITBA/EXM/F/EXM44/2025-26/1087214105(1). ",
    "Donations to our trust are eligible for tax deduction under section 80G of the Income Tax Act, 1961 vide registration no. DIT (E)/2009-10/DEL-CE-21482-04022010/3001 dated 04.02.2010. The registration was renewed for 5 years on 11/03/2026 from AY 2027-28 to AY 2031-32 vide unique registration number AABTC0541K25DL02 and Document Identification Number ITBA/EXM/F/EXM44/2025-26/1087214135(1). "
  ]

  const year1 = [
    {year : "2009-10",url:'https://drive.google.com/file/d/1Vn9T3Fc2r7ykTMZeqFCGCbvSoSnx99Je/view?usp=sharing'},
    {year : "2010-11",url:'https://drive.google.com/file/d/1k9jrqCXsVbldRL5Tr1RitKORLRUo7hXI/view?usp=sharing'},
    {year : "2011-12",url:'https://drive.google.com/file/d/1Ti8wqDxMwmInvL9x6JwtYhfD0WlrespB/view?usp=sharing'},
    {year : "2012-13",url:'https://drive.google.com/file/d/1q4iyiiS4FHJ_eQ-tivFUug8PVysK8Iid/view?usp=sharing'},
    {year : "2013-14",url:'https://drive.google.com/file/d/1wWA7we-H2kX0_GJ8JX6y_Mqua7IekGIy/view?usp=sharing'},
    {year : "2014-15",url:'https://drive.google.com/file/d/1jTkLdinEQHgypfEMtG_qgZhnVKOGTCFv/view?usp=sharing'},
    {year : "2015-16",url:'https://drive.google.com/file/d/1bQBLehzzMUfxtzHj3KesXzl-dVkrv9Z9/view?usp=sharing'},
    {year : "2016-17",url:'https://drive.google.com/file/d/1nxey-B-LOXr5jVtWPsA0HX3S8ZTCRjT_/view?usp=sharing'},
    {year : "2017-18",url:'https://drive.google.com/file/d/1B-LXTDBEUwtWcD9PBw83yVGULPjkbi1_/view?usp=sharing'},
    {year : "2018-19",url:'https://drive.google.com/file/d/1ZGcSjuihi80hZtIdDx-zA5k_8mTk_hFx/view?usp=sharing'},
    {year : "2019-20",url:'https://drive.google.com/file/d/1B9Gal5qzftARrgAbIZjXtPbm5xFGwByD/view?usp=sharing'},
    {year : "2020-21",url:'https://drive.google.com/file/d/1xQ57Kv148rb7CyVkcKCcP0aPZk0IVvT-/view?usp=sharing'},
    {year : "2021-22",url:'https://drive.google.com/file/d/16EMzbu9Bt3_Wfb29SL87jNIj5QBEkXib/view?usp=sharing'},
    {year : "2022-23",url:'https://drive.google.com/file/d/13Lb0hs0UrVeGMyElNZMXwS87Y6i8NKLB/view?usp=sharing'},
    {year : "2023-24",url:'https://drive.google.com/file/d/1glPQmrK_V2Cs8MbsONoH1cb4R_rZ3Dqg/view?usp=sharing'},
    {year : "2024-25",url:'https://drive.google.com/file/d/1cEmwIkQ9AYyj2EgKWelyqevntmU_y0Km/view?usp=sharing'},
    {year : "2025-26",url:'https://drive.google.com/file/d/1E791NLNzVvDR7uywXfccUDifBrRsjXX_/view?usp=sharing'},
  ]
  const year2 = [
    {year : "2010-11",url:'https://drive.google.com/file/d/17_fs6A8qfuVtIvLad7XPKDBP3wPdtTGd/view'},
    {year : "2011-12",url:'https://drive.google.com/file/d/1-XqEeGBReCOohObWkIzA4kYiSPy2c09H/view'},
    {year : "2012-13",url:'https://drive.google.com/file/d/1y9SIspkbL6Xb-fdwRWtSO7ShgqnyoK0g/view'},
    {year : "2013-14",url:'https://drive.google.com/file/d/1U3H4pJ-PKpCrTcRNGDe3QExOYCg9jrc1/view'},
    {year : "2014-15",url:'https://drive.google.com/file/d/1scXtyvwBZUucZPY8lf2jw6F5Y1c6mqqx/view'},
    {year : "2015-16",url:'https://drive.google.com/file/d/1jtMXQVwwNLwaqRZlU8_RGyiVPlpwgNJ7/view'},
    {year : "2016-17",url:'https://drive.google.com/file/d/1DPjtgLBkRtBle8OFfMVEetTJoCV-XejJ/view'},
    {year : "2017-18",url:'https://drive.google.com/file/d/1ASSV2kpDn7DA3DyEcRa9Y6ACJ3-AkMmP/view'},
    {year : "2018-19",url:'https://drive.google.com/file/d/1de2H17jAo9OTVAKuvzEf7yGO29bPkTeJ/view'},
    {year : "2019-20",url:'https://drive.google.com/file/d/1-SCTOl0JnaMgMVeBKar27vbTWM47JFCi/view'},
    {year : "2020-21",url:'https://drive.google.com/file/d/13wVwWKc9UQitIq_9oC27zlAEOSVtvtDW/view'},
    {year : "2021-22",url:'https://drive.google.com/file/d/1OwgeldyNu86SX_E5XX7aJvgAmrd8ygVW/view'},
    {year : "2022-23",url:'https://drive.google.com/file/d/1d7b2eyC7ymX3uLVpRWaqbjpsKUrSXHET/view'},
    {year : "2023-24",url:'https://drive.google.com/file/d/1onl6uDjWrFtA3a8jtBxGb0SP2OY10ZV6/view?usp=sharing'},
    {year : "2024-25",url:'https://drive.google.com/file/d/1lbkv2Mj7-gWZA0pnzvrhFht_Cg3hwLbd/view?usp=sharing'},
    {year : "2025-26",url:'https://drive.google.com/file/d/1ayFhFWja0vqHEomIHyFs1xf4J6YQwWsu/view?usp=sharing'},
  ]
  const year3_1 = [
    {yearHead:'Q1'},
    {yearHead:'-'},
    {year : "2016-17",url:'https://drive.google.com/file/d/1NlSXzFH17pNyzTLj1iSGo902Q2-XYL_4/view'},
    {year : "2017-18",url:'https://drive.google.com/file/d/1q-PLglaROi3mEMgcD-ZiKQABhaEY1Lxe/view'},
    {year : "2018-19",url:'https://drive.google.com/file/d/141WCWtH3tMzWLyOadtDpKcBHDq0sf7WE/view'},
    {year : "2019-20",url:'https://drive.google.com/file/d/1cMjbFv2iQqE4O6zASkw_TkiyQ622gscF/view'},
    {year : "2020-21",url:'https://drive.google.com/file/d/1h-3HaShHAqQa10vHf4q8b4B23aO4mzyx/view'},
    {year : "2021-22",url:'https://drive.google.com/file/d/1h-3HaShHAqQa10vHf4q8b4B23aO4mzyx/view'},
    {year : "2022-23",url:'https://drive.google.com/file/d/1C4GH8ViTIWX61n-DkeVF5_SqJakdYm8H/view'},
    {year : "2023-24",url:'https://drive.google.com/file/d/1S7J2clayxdVIaFe7JgHgVGlRCwFiMEJo/view?usp=sharing'},
    {year : "2024-25",url:'https://drive.google.com/file/d/1Lo3qQcP3PLYaRZndbWgl4shPEAgB2Mjn/view?usp=sharing'},
    {year : "2025-26",url:'https://drive.google.com/file/d/1hHtSDU-QmUzYuzbOcnAQmUhq6wGgGRiH/view?usp=sharing'},
    {year : "2026-27",url:'https://drive.google.com/file/d/1BllIhATxc-hHYSdVwIRR6bQ-BWL6gyj-/view?usp=sharing'},
    
  ]
  const year3_2 = [
    
    {yearHead:'Q2'},
    {yearHead:'-'},
    {year : "2016-17",url:'https://drive.google.com/file/d/1de1KiEdRxH9TRezGwKM91AMAHdYMWESq/view'},
    {year : "2017-18",url:'https://drive.google.com/file/d/17IY4h4X73v8lE49EG5-eB0rZQIUh4ZyK/view'},
    {year : "2018-19",url:'https://drive.google.com/file/d/1625nf2161sWqV3ZShSOS_w0ZTESZRzQc/view'},
    {year : "2019-20",url:'https://drive.google.com/file/d/1m1ufKfNWHkC8GzIAGqP_czdctWcEOSml/view'},
    {year : "2020-21",url:'https://drive.google.com/file/d/1zLcg2sWMFtxBCayMopfedJsM6CxOhzjg/view'},
    {year : "2021-22",url:'https://drive.google.com/file/d/1zLcg2sWMFtxBCayMopfedJsM6CxOhzjg/view'},
    {year : "2022-23",url:'https://drive.google.com/file/d/1zj0PXlf2s3R0CKQVaykYJU7rYG-EL4wu/view'},
    {year : "2023-24",url:'https://drive.google.com/file/d/1bbEtRor2YJBdCxf7DqebXl1wvqyxyog9/view?usp=sharing'},
    {year : "2024-25",url:'https://drive.google.com/file/d/1stwD249ivclzR8iqCptBp33jWPkO5oZn/view?usp=sharing'},
    {year : "2025-26",url:'https://drive.google.com/file/d/1CQkx2GbI_joRC3egtqVoCZPCt26zFh82/view?usp=sharing'},
    {year : "2026-27",url:'https://drive.google.com/file/d/18Z6E8lHXDv7O7FQhmBAC_Ea02lmglBVW/view?usp=sharing'},
    
  ]
  const year3_3 = [
    
    {yearHead:'Q3'},
    {year : "2015-16",url:'https://drive.google.com/file/d/1H-Kye5NdYIqWk44Zgqa2m2TaJ5qGp5vD/view'},
    {year : "2016-17",url:'https://drive.google.com/file/d/1pDsPwZxqi8Lspj8zbyjXXNwHm5AWM4j4/view'},
    {year : "2017-18",url:'https://drive.google.com/file/d/1utkc_x7ElmJvoqLv5bDUPGeiaXNTqmnk/view?usp=sharing'},
    {year : "2018-19",url:'https://drive.google.com/file/d/1KwxFxvNnVg9P2HlloMJ8qjXRQzpDbwVH/view'},
    {year : "2019-20",url:'https://drive.google.com/file/d/1RzMTKdMQqyE4Ck16WzL8D_xRk3vaCSd5/view'},
    {year : "2020-21",url:'https://drive.google.com/file/d/1dGRsMRi19pMqgE5_vzcjvLl8KtI1GKVb/view'},
    {year : "2021-22",url:'https://drive.google.com/file/d/1dGRsMRi19pMqgE5_vzcjvLl8KtI1GKVb/view'},
    {year : "2022-23",url:'https://drive.google.com/file/d/1LdvxmuTutSDCnBMkfqn2vcoUi_tAsjbb/view'},
    {year : "2023-24",url:'https://drive.google.com/file/d/1V1vl_xSTlpB5MI8oZDFM0yyL36rWt6ru/view?usp=sharing'},
    {year : "2024-25",url:'https://drive.google.com/file/d/1aadjen0e8lgdYTLmOgQQxoyNrAKcoDzF/view?usp=sharing'},
    {year : "2025-26",url:'https://drive.google.com/file/d/193aDNyvgX3bnZRcZLfIw_nYFF78dlCDQ/view?usp=sharing'},
    {year : "2026-27",url:'https://drive.google.com/file/d/1yM-Qd3Ffdro9Hzd3ATWpdN6ipkfxcPjS/view?usp=sharing'}
    
  ]
  const year3_4 = [
    
    {yearHead:'Q4'},
    {year : "2015-16",url:'https://drive.google.com/file/d/1LmygT4yDhNBlUVMeVJCCSnFodYkDoRor/view'},
    {year : "2016-17",url:'https://drive.google.com/file/d/1UY8R1WbIdoQgqdIbXKwvDxksAycIefK-/view?usp=sharing'},
    {year : "2017-18",url:'https://drive.google.com/file/d/17SX6Auv0Es0B5LznCkqunTd0QHJVowh5/view?usp=sharing'},
    {year : "2018-19",url:'https://drive.google.com/file/d/1Ic3LIIhfEOCzoSQujNYcjLvBHGVWxEeO/view'},
    {year : "2019-20",url:'https://drive.google.com/file/d/14ZhXGjEpuVmRavDaUAbxCSZzn3nlZm7P/view'},
    {year : "2020-21",url:'https://drive.google.com/file/d/1L4ngL_uiGKfdktwGzpTYiYs16mM7XYGf/view'},
    {year : "2021-22",url:'https://drive.google.com/file/d/1L4ngL_uiGKfdktwGzpTYiYs16mM7XYGf/view'},
    {year : "2022-23",url:'https://drive.google.com/file/d/1DkA0edifOyWZcm70WkU98_5ycNS5DEJW/view'},
    {year : "2023-24",url:'https://drive.google.com/file/d/1jAYA1yFH4xjWc5jS1apUP8gh-yFQq6YQ/view?usp=sharing'},
    {year : "2024-25",url:'https://drive.google.com/file/d/1hhuIGK7oP_RX6f0OwAwETCCb01SeqWdC/view?usp=sharing'},
    {year : "2025-26",url:'https://drive.google.com/file/d/1ORneAKfBn9Y9nBP33C3biKzpiY2ntLVe/view?usp=sharing'},
    {year : "2026-27",url:'https://drive.google.com/file/d/1NI1a5ov1j7-bXsp2Qy4pDXjk4ydeVcB6/view?usp=sharing'}
  ]
  return (
    <div className="max-w-screen overflow-hidden text-black">
      <HeaderSec />

      <div className="max-w-[1200px] m-auto min-h-[500px]">
        <AboutSecComp
          topic={"Statutory Information & FCRA Compliance"}
          section={section1}
          image={statutory}
        />

        <div className="flex ">
          <div className="w-[250px]">
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              Our IT PAN
            </Typography>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              Our TAN
            </Typography>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              Our Darpan ID
            </Typography>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              Our FCRA Registration No. 
            </Typography>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              Our GuideStar Number
            </Typography>
          </div>
          <div>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              : AABTC0541K
            </Typography>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              : DELC11144A
            </Typography>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              : MH/2009/0005254 
            </Typography>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              : 084020010
            </Typography>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              : 555 
            </Typography>
            
          </div>
        </div>

        <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 600,    margin: '10px 0 5px 0',     lineHeight: 1.6  }}>
            Please click on the year to view the respective document.
            </Typography>
        <AboutSecComp
          header={"Our Consolidated Annual Audited Accounts"}
          yearsList={year1}
        />
        <AboutSecComp
          header={"FCRA Compliance Reporting "}
          pointHead={"FCRA Annual Accounts"}
          yearsList={year2}
        />
        
        <AboutSecComp
          pointHead={"FCRA Quarterly Receipts"}
        />

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            {year3_1.map((ele, i) => (
              <div className="flex gap-1" key={i}>
                <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 600,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>{ele.yearHead}</Typography>
                <a href={ele.url} style={{ textDecoration: 'none', color: '#004878' , lineHeight:1.6}} target="_blank" rel="noreferrer">
                  <Typography variant="body1"  sx={{ lineHeight:2.6,   '&:hover': {     textDecoration: 'underline',     color: '#004878'   } }}>
                    {ele.year}
                  </Typography>
                </a>
              </div>
            ))}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            {year3_2.map((ele, i) => (
              <div className="flex gap-1" key={i}>
                <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 600,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>{ele.yearHead}</Typography>
                <a href={ele.url} style={{ textDecoration: 'none', color: '#004878' , lineHeight:1.6}} target="_blank" rel="noreferrer">
                  <Typography variant="body1"  sx={{ lineHeight:2.6,   '&:hover': {     textDecoration: 'underline',     color: '#004878'   } }}>
                    {ele.year}
                  </Typography>
                </a>
              </div>
            ))}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            {year3_3.map((ele, i) => (
              <div className="flex gap-1" key={i}>
                <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 600,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>{ele.yearHead}</Typography>
                <a href={ele.url} style={{ textDecoration: 'none', color: "#004878"  , lineHeight:1.6 }} target="_blank" rel="noreferrer">
                  <Typography variant="body1"  sx={{ lineHeight:2.6,   '&:hover': {     textDecoration: 'underline',     color: '#004878'   } }}>
                    {ele.year}
                  </Typography>
                </a>
              </div>
            ))}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            {year3_4.map((ele, i) => (
              <div className="flex gap-1" key={i}>
                <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 600,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>{ele.yearHead}</Typography>
                <a href={ele.url} style={{ textDecoration: 'none', color: '#004878' , lineHeight:1.6}} target="_blank" rel="noreferrer">
                  <Typography variant="body1"  sx={{ lineHeight:2.6,   '&:hover': {     textDecoration: 'underline',     color: '#004878'   } }}>
                    {ele.year}
                  </Typography>
                </a>
              </div>
            ))}
          </Grid>
        </Grid>



        <AboutSecComp
          header={"Filing of Statutory Returns"}
        />
        <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
          All our Income Tax and FCRA returns are filed on time. 
        </Typography>
        <AboutSecComp
          header={"List of Board of Trustees"}
        />

        <div className="flex ">
          <div className="w-[40px]">
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              1.
            </Typography>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              2.
            </Typography>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              3.
            </Typography>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              4.
            </Typography>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              5.
            </Typography>
          </div>
          <div>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              Mr. Bishambar Nath Makhija, Chairperson
            </Typography>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              Mr. Anshu Gupta
            </Typography>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              Ms. Jyotsna Sitling
            </Typography>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              Mr. Ankur Sarin
            </Typography>
            <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',     lineHeight: 1.6  }}>
              Mr. Noshir H. Dadrawala
            </Typography>
          </div>
        </div>

      </div>

      <FooterComp />
    </div>
  );
};

export default StatutoryInformation;
